export const loginState = {
  name: 'login',
  url: '/login',
  views: {
    'main@': 'loginComponent',
  },
}

export const resetPasswordState = {
  name: 'password',
  url: '/password',
  views: {
    'main@': 'resetPasswordComponent',
  },
}

export const newPasswordState = {
  name: 'password.new',
  url: '/new',
  views: {
    'main@': 'newPasswordComponent',
  },
}

export const activateAccountState = {
  name: 'account',
  url: '/activate',
  views: {
    'main@': 'activateAccountComponent',
  },
  resolve: {
    cookie: ($cookies) => {
      'ngInject'
      const decoded = $cookies.get('umsema') ? JSON.parse(window.atob($cookies.get('umsema'))) : null
      if (decoded && decoded.email && decoded.token) return decoded
      else return null
    },
  },
}



// WEBPACK FOOTER //
// ./app/account/account.states.js